import Tooltip from '@mui/material/Tooltip';
import colors from '@/utils/colors';

const SmartTooltip = ({
    children,
    variant = 'secondary',
    placement = 'top',
    content,
    variantCode = 600, // DEFAULT
    containerClassName = 'w-fit',
}) => {
    return (
        <Tooltip
            title={<div style={{ padding: '8px' }}>{content}</div>}
            placement={placement}
            arrow
            slotProps={{
                tooltip: {
                    sx: {
                        color: `${variantCode < 450 ? colors[variant][950] : colors[variant][50]}`,
                        bgcolor: `${colors[variant][variantCode]}`,
                        '& .MuiTooltip-arrow': {
                            color: `${colors[variant][variantCode]}`,
                        },
                        p: 0,
                    },
                },
            }}
        >
            <div className={containerClassName}>{children}</div>
        </Tooltip>
    );
};

export default SmartTooltip;
